/* eslint-disable no-underscore-dangle */
import {AnyAction, isRejectedWithValue} from '@reduxjs/toolkit';
import type {MiddlewareAPI, Middleware} from '@reduxjs/toolkit';
import {RootState} from 'store';

interface ErrorSubscriber {
  matcher: (action: AnyAction) => boolean;
  callback: (
    action: AnyAction,
    api: MiddlewareAPI,
    preActionState: RootState
  ) => void;
}

const errorSubscribers: ErrorSubscriber[] = [];

export const addErrorSubscriber = (sub: ErrorSubscriber): void => {
  errorSubscribers.push(sub);
};

const errorSubscriberMiddleware: Middleware =
  (api: MiddlewareAPI) => next => (action: AnyAction) => {
    const preActionState = api.getState();
    next(action);

    setTimeout(() => {
      errorSubscribers.forEach(sub => {
        if (isRejectedWithValue(action) && sub.matcher(action)) {
          sub.callback(action, api, preActionState);
        }
      });
    });
  };

export default errorSubscriberMiddleware;
